import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ModalComponent from '../../../layout/Modals/ModalComponent/ModalComponent';
import { connectModalContainerContextToComponent } from '../../../../contexts/ModalContext/ModalContext';
import { facetTypeDetails } from '../../../../utility/types/facetTypeDetails';
import { filterModalType } from '../../../../utility/types/filterModalType';
import FilterModalPatternA from './FilterModalPatterns/FilterModalPatternA/FilterModalPatternA';
import FilterModalPatternB from './FilterModalPatterns/FilterModalPatternB/FilterModalPatternB';
import FilterModalPatternC from './FilterModalPatterns/FilterModalPatternC/FilterModalPatternC';
import FilterModalPatternE from './FilterModalPatterns/FilterModalPatternE/FilterModalPatternE';
import FilterModalPatternD from './FilterModalPatterns/FilterModalPatternD/FilterModalPatternD';
import useFacets from '../../../hooks/useFacets/useFacets';
import searchFilterPropType from '../../../../utility/PropTypes/searchFilterPropType';
import createFacet from '../../../../classes/facets/FacetFactory';
import FilterModalPatternF from './FilterModalPatterns/FilterModalPatternF/FilterModalPatternF';
import FilterModalPatternG from './FilterModalPatterns/FilterModalPatternG/FilterModalPatternG';

function ListFilterModal({
  setModalJSX,
  facetTypeId,
  facetSelectOptions,
  filterToEdit,
  updateFilters,
  searchType,
}) {
  const [show, setShow] = useState(true);
  const {
    facets,
    setFacets,
    removeFacet,
    addFacet,
    updateFacet,
    clearFacets,
  } = useFacets(filterToEdit);

  const FacetClass = createFacet(facetTypeId);
  const facetTypeDetail = facetTypeDetails[facetTypeId];
  const closeModalHandler = () => {
    setShow(false);
    setModalJSX((<></>));
  };

  const handleSubmitFilter = () => {
    updateFilters(facets, facetTypeId);
    closeModalHandler();
  };

  const selectedModalPattern = (modalType) => {
    /* istanbul ignore next */
    const componentByModalType = {
      [filterModalType.A]: (props) => <FilterModalPatternA {...props} />,
      [filterModalType.B]: (props) => <FilterModalPatternB {...props} />,
      [filterModalType.C]: (props) => <FilterModalPatternC {...props} />,
      [filterModalType.D]: (props) => <FilterModalPatternD {...props} />,
      [filterModalType.E]: (props) => <FilterModalPatternE {...props} />,
      [filterModalType.F]: (props) => <FilterModalPatternF {...props} />,
      [filterModalType.G]: (props) => <FilterModalPatternG {...props} />,
    };
    return componentByModalType[modalType];
  };

  const Component = selectedModalPattern(facetTypeDetail.modalType);

  return (
    <ModalComponent
      show={show}
      close={closeModalHandler}
      showConfirmCallToAction
      confirmButtonText={filterToEdit.length > 0 ? 'Save' : 'Add'}
      confirmButtonAction={handleSubmitFilter}
      isBtnDisabled={!facets.length}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {`Filter On ${facetTypeDetail.displayValue}`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <Component
            facetType={facetTypeDetail}
            facetClass={FacetClass}
            facets={facets}
            setFacets={setFacets}
            addFacet={addFacet}
            removeFacet={removeFacet}
            updateFacet={updateFacet}
            clearFacets={clearFacets}
            facetSelectOptions={facetSelectOptions}
            searchType={searchType}
          />
        </form>
      </Modal.Body>
    </ModalComponent>
  );
}

ListFilterModal.defaultProps = {
  filterToEdit: [],
};
ListFilterModal.propTypes = {
  setModalJSX: PropTypes.func.isRequired,
  facetTypeId: PropTypes.number.isRequired,
  facetSelectOptions: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }),
  ).isRequired,
  filterToEdit: PropTypes.arrayOf(
    PropTypes.shape(searchFilterPropType),
  ),
  updateFilters: PropTypes.func.isRequired,
  searchType: PropTypes.number.isRequired,
};
export default connectModalContainerContextToComponent(ListFilterModal);
